export default __webpack_public_path__ + "static/media/airhorn.a766e946.mp3";